import { Table } from 'antd';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { type UserlikeChatbotModuleSpecsFragment } from '../../../../api/fragments/UserlikeChatbotModuleSpecs';
import UserlikeChatbotSettingActions from './UserlikeChatbotSettingActions';

export type UserlikeChatbotSettingsTableProps = {
    module: UserlikeChatbotModuleSpecsFragment;
};

export type ItemSpecs = UserlikeChatbotModuleSpecsFragment['chatbotSettings'][number];

const UserlikeChatbotSettingsTable = ({ module }: UserlikeChatbotSettingsTableProps) => {
    const { t } = useTranslation(['userlikeChatbotModuleDetails']);

    const renderActions = useCallback(
        (record: ItemSpecs) => <UserlikeChatbotSettingActions module={module} settings={record} />,
        [module]
    );

    return (
        <Table dataSource={module.chatbotSettings} rowKey="id">
            <Table.Column
                key="displayName"
                dataIndex="displayName"
                title={t('userlikeChatbotModuleDetails:settingsTable.columns.displayName')}
            />
            <Table.Column
                key="actions"
                align="center"
                render={renderActions}
                title={t('userlikeChatbotModuleDetails:settingsTable.columns.actions')}
                width={100}
            />
        </Table>
    );
};

export default UserlikeChatbotSettingsTable;
